import LicensesUtils from '@/composables/LicensesUtils';
const { getTimeNowPlusSeconds } = LicensesUtils()

export default {
    namespaced: true,
    state: {
        licenses: []
    },
    mutations: {
        setLicenses(state, licensesInfo) {
            // Add a Dictionary element => activation (info for the current status)
            const licensesInfoWithActivationsKey = licensesInfo.map(obj => {
                let res = {...obj}
                // If pending status, calculate the local time of expiration based on the number of seconds
                if (res.pending) {
                    if (res.pending.pending_release) {
                        res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_release.remaining_time_s)}}}
                    }
                    if (res.pending.pending_reactivate) {
                        res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_reactivate.remaining_time_s)}}}
                    }
                }
                return res
            })
            state.licenses = licensesInfoWithActivationsKey;
        },
        clearLicenses(state) {
            state.licenses = [];
        },
        addLicense(state, addedLicenseInfo) {
            console.log("addLicense: ", addedLicenseInfo)
            // Make sure the license is not already in the array : add only if not yet
            if (!state.licenses.some((license) => license.serial_number == addedLicenseInfo.serial_number)) {
                let res = {...addedLicenseInfo}
                // If pending status, calculate the local time of expiration based on the number of seconds
                if (res.pending) {
                    if (res.pending.pending_release) {
                        res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_release.remaining_time_s)}}}
                    }
                    if (res.pending.pending_reactivate) {
                        res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_reactivate.remaining_time_s)}}}
                    }
                }
                state.licenses.push(res)
            }
        },
        removeLicense(state, removedLicenseSerial) {
            console.log("removeLicense: ", removedLicenseSerial)
            state.licenses = state.licenses.filter((license) => license.serial_number !== removedLicenseSerial)
        },
        updateLicenseDelegates(state, updatedLicenseInfo) {
            // Update the delegates for the serial number
            state.licenses = state.licenses.map((license) => {
                if (license.serial_number === updatedLicenseInfo.serial_number) {
                    return { ...license, ['delegates']: updatedLicenseInfo.delegates }
                }
                return license
            })
        },
        forgetDelegate(state, delegateToForgetId) {
            // Update the delegates for the serial number
            state.licenses = state.licenses.map((license) => {
                return { ...license, ['delegates']: license.delegates.filter((d) => d.id !== delegateToForgetId) }
            })
        },
        updateLicenseHistoryAndPendingInfo(state, updatedLicenseInfo) {
            // Update the history for the serial number (and the pending if there is)
            state.licenses = state.licenses.map((license) => {
                if (license.serial_number === updatedLicenseInfo.serial_number) {
                    let res = { ...license, current_status: updatedLicenseInfo.current_status, history: updatedLicenseInfo.history }
                    // If pending status, calculate the local time of expiration based on the number of seconds
                    if (updatedLicenseInfo.pending) {
                        res = {...res, pending: {...updatedLicenseInfo.pending}}
                        if (updatedLicenseInfo.pending.pending_release) {
                            res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_release.remaining_time_s)}}}
                        }
                        if (updatedLicenseInfo.pending.pending_reactivate) {
                            res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_reactivate.remaining_time_s)}}}
                        }
                    }
                    return res
                }
                return license
            })
        }
    },
    actions: {
        updateLicense({ commit }, updatedLicenseInfo) {
            console.log("updateLicense: ", updatedLicenseInfo)
            commit('removeLicense', updatedLicenseInfo.serial_number)
            commit('addLicense', updatedLicenseInfo)
        }
    },
    getters: {
        isEmpty: state => !state.licenses.count>0,
        allApplications: state => {
            // Retrieve all applications
            const tempA = state.licenses.value.map((license) => license.product.application)
            // Remove duplications
            const tempB = tempA.filter((value, index, self) => {
                return self.findIndex(obj =>
                    obj === value
                ) === index;
            });
            // Alphabetical order
            const res = tempB.sort((a,b) => {
                const nameA = a.toLowerCase()
                const nameB = b.toLowerCase()
                if (nameA < nameB) { return -1 }
                else if (nameA > nameB) { return 1 }
                else { return 0 }
            })
            return res
        }
    }
};